<div class="asset-filter">
  <div class="asset-filter--header">
    <h2 class="asset-filter--title">
      Filters
      @if (config.activeFilterCount > 0) {
        <span class="asset-filter--count">{{ config.activeFilterCount }}</span>
      }
    </h2>

    @if (config.activeFilterCount > 0) {
      <button type="button" class="asset-filter--reset" (click)="onReset()">Clear all</button>
    }
  </div>

  <div class="asset-filter--sections">
    @for (section of config.sections; track section.id) {
      @let sectionIconSrc = getSectionIcon(section);
      @if (section.id !== 'bookmarks') {
        <div class="asset-filter--section">
          <button
            type="button"
            class="asset-filter--section-header"
            (click)="toggleSection(section.id)"
            [attr.aria-expanded]="section.isExpanded === true"
          >
            <div class="asset-filter--section-title-row">
              @if (sectionIconSrc) {
                <img [src]="sectionIconSrc" alt="" class="asset-filter--section-icon" />
              }
              <span class="asset-filter--section-title">{{ section.title }}</span>
            </div>

            <img
              src="/icons/chevron-down.svg"
              alt=""
              class="asset-filter--section-chevron"
              [class.asset-filter--section-chevron--expanded]="section.isExpanded"
            />
          </button>

          @if (section.isExpanded) {
            <div class="asset-filter--section-panel" (click)="$event.stopPropagation()">
              @if ((section.type === 'checkbox' || section.type === 'radio') && section.options?.length) {
                <div class="asset-filter--options">
                  @if (section.options) {
                    @for (option of section.options; track option.id) {
                      <label class="asset-filter--option">
                        <span class="asset-filter--input-wrap">
                          <input
                            type="checkbox"
                            class="asset-filter--checkbox-input"
                            [checked]="option.checked"
                            (click)="onCheckboxClick($event, section.id, option.id)"
                          />
                          <span
                            class="checkbox-checkmark-custom asset-filter--checkbox-visual"
                            [class.checked]="option.checked"
                          ></span>
                        </span>
                        <span class="asset-filter--option-label">{{ option.label }}</span>
                      </label>
                    }
                  }
                </div>
              }
            </div>
          }
        </div>
      }
    }
  </div>
</div>
